import { keyframes, styled } from "goober";

const shimmer = keyframes`
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
`;

export const ShimmerSpan = styled("span")`
  &[data-pending="true"] {
    background: linear-gradient(
      90deg,
      var(--text-secondary) 30%,
      var(--text-primary) 50%,
      var(--text-secondary) 70%
    );
    background-size: 200% 100%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: ${shimmer} 2.5s linear infinite;
  }
`;
